
function removeHtmlExtension() {
    var url = window.location.href;
    var cleanUrl = url.replace(/\.html$/, '');
    var noIndex = cleanUrl.replace('index','');
    history.replaceState({}, document.title, noIndex);
}
removeHtmlExtension();

"use strict";
window.Webflow ||= [];
window.Webflow.push(async () => {


});